












































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { AuditLog } from '@/store/modules/audit-log/types/audit-log.types';
import dayjs from 'dayjs';
import { PaymentStatusTypes } from '../../../store/types/general.types';
import {
  BPointV3TxnResp,
  BPointV5TxnResp
} from '@/store/modules/order/order.types';

@Component({})
export default class AuditLogModal extends Vue {
  @Prop() public auditLogId!: number;
  @Prop() public items!: AuditLog[];

  get AuditLog() {
    return this.items.find((res) => res.id === this.auditLogId);
  }

  public toUpperCase(str?: string) {
    if (!str) {
      return 'N/A';
    }
    return str.charAt(0).toUpperCase() + str.slice(1) + ' Card';
  }

  get getBillingAddress() {
    if (!this.AuditLog?.transaction_status.billingAddress) {
      return 'N/A';
    }
    return this.AuditLog?.transaction_status.billingAddress;
  }

  get getCardHolder() {
    if (!this.AuditLog?.txnResp) {
      return 'N/A';
    }

    return (
      (this.AuditLog.txnResp as BPointV3TxnResp)?.CardDetails?.CardHolderName ||
      'N/A'
    );
  }

  get getPaymentMethod() {
    if (!this.AuditLog?.txnResp) {
      return 'N/A';
    }

    return (
      (this.AuditLog.txnResp as BPointV3TxnResp)?.CardDetails?.SubType ||
      (this.AuditLog.txnResp as BPointV5TxnResp).subType ||
      'N/A'
    );
  }

  get getCardNumber() {
    if (!this.AuditLog?.txnResp) {
      return 'N/A';
    }

    const cardNumber =
      (this.AuditLog?.txnResp as BPointV3TxnResp)?.CardDetails
        ?.MaskedCardNumber ||
      (this.AuditLog?.txnResp as BPointV5TxnResp).paymentMethod.card.number;

    const cardType =
      (this.AuditLog?.txnResp as BPointV3TxnResp).CardType ||
      (this.AuditLog?.txnResp as BPointV5TxnResp).paymentMethod.card.type;

    const maskedNumber = `${cardType} - XXXXXXXXXXXXX${cardNumber.substr(
      cardNumber.length - 3
    )}`;
    return maskedNumber;
  }

  public formatDate(date: Date) {
    const result = dayjs(date).format('D MMMM YYYY h:mm A');

    return result === 'Invalid Date' ? 'N/A' : result;
  }

  public getTransactionStatus(paymentStatus: PaymentStatusTypes) {
    return paymentStatus === PaymentStatusTypes.SUCCESS
      ? 'Successful'
      : paymentStatus === PaymentStatusTypes.FAILED
      ? 'Failed'
      : 'Pending';
  }
}
